module.exports = __webpack_public_path__ + "static/media/notes-arrow.7b256d04.svg";